/* Hello couleur — interactivité page panier.
   Update qty / remove / clear via /cart/change.js (Ajax Cart API Shopify).
   Stratégie simple : à chaque action, on POST puis on reload pour resync
   complet du DOM côté serveur. Pas de manipulation manuelle des totaux JS. */
(function () {
  var itemsContainer = document.getElementById('cart-items');
  if (!itemsContainer) return;

  function postChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function changeQty(line, qty) {
    return postChange({ line: line, quantity: qty });
  }

  function reload() { window.location.reload(); }

  itemsContainer.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-action]');
    if (!btn) return;
    var item = btn.closest('.cart-item');
    if (!item) return;
    var line = parseInt(item.dataset.line, 10);
    var qtyInput = item.querySelector('[data-qty]');
    var current = parseInt(qtyInput.value, 10) || 1;
    // 2026-10-02 B2B : pas et minimum lus sur le champ (règles pro ; public = 1 / 1)
    var step = parseInt(qtyInput.step, 10) || 1, qmin = parseInt(qtyInput.min, 10) || 1;
    var action = btn.dataset.action;

    if (action === 'inc') {
      // 2026-10-21 : plafond lu sur le champ (= stock restant), au lieu de 99 en dur.
      var qmax = parseInt(qtyInput.getAttribute('max'), 10) || (step > 1 ? 990 : 99);
      var note = item.querySelector('[data-qty-note]');
      // Deja au maximum : on affiche l'explication plutot que de ne rien faire (et on evite un rechargement inutile).
      if (current >= qmax) { if (note) note.hidden = false; return; }
      if (current + step >= qmax && note) note.hidden = false;
      changeQty(line, Math.min(qmax, current + step)).then(reload);
    } else if (action === 'dec') {
      var next = current - step;
      if (next < qmin) {
        changeQty(line, 0).then(reload);
      } else {
        changeQty(line, next).then(reload);
      }
    } else if (action === 'remove') {
      changeQty(line, 0).then(reload);
    }
  });

  // Update qty au blur / change sur l'input (saisie directe)
  itemsContainer.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty]')) return;
    var item = e.target.closest('.cart-item');
    if (!item) return;
    var line = parseInt(item.dataset.line, 10);
    var qty = parseInt(e.target.value, 10);
    var step = parseInt(e.target.step, 10) || 1, qmin = parseInt(e.target.min, 10) || 1;
    if (isNaN(qty) || qty < qmin) qty = qmin;
    var qmax = parseInt(e.target.getAttribute('max'), 10) || (step > 1 ? 990 : 99);
    if (qty > qmax) qty = qmax;
    var noteT = item.querySelector('[data-qty-note]');
    if (qty >= qmax && noteT) noteT.hidden = false;
    qty = Math.ceil(qty / step) * step;
    e.target.value = qty;
    changeQty(line, qty).then(reload);
  });

  // Bouton "Vider mon panier"
  var clearBtn = document.getElementById('cart-clear-btn');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (!confirm('Voulez-vous vider entièrement votre panier ?')) return;
      fetch('/cart/clear.js', { method: 'POST' }).then(reload);
    });
  }
})();
